export type Job = {
  id: string
  title: string
  location: string
  type: string
  remote: string
  featured: boolean
  employer: string
  role: string
  createdAt: Date
  description: string
  applications: string[]
}

const tempDescription = `<h1>Key Responsibilities:</h1>
<ul>
    <li>Perform technical support, troubleshoot, and provide Root Cause Analysis on complex issues effectively and efficiently in line with the SLA required by the business.</li>
    <li>Provide emergency on-site support and coordination, and on-call support as required.</li>
    <li>Resolve and manage complex service requests in adherence with service level agreements.</li>
    <li>Assess and define operating procedures used for day-to-day support, installation guides, housekeeping procedures, etc.</li>
    <li>Perform complex ad-hoc requests.</li>
    <li>Provide expertise in complex database software installation and configuration.</li>
    <li>Provide expertise in complex database administration and monitoring.</li>
    <li>Provide expertise in tuning to improve efficiency and to maximize the availability of databases and process automation of software environments and the like.</li>
    <li>Create scripts for monitoring and to automate administrative tasks.</li>
    <li>Provide data protection and enforce security standard procedures.</li>
    <li>Ensure that information security policy is considered and always followed,</li>
    <li>Recommends any changes to policy and approved policy changes are documented.</li>
    <li>Assist superiors and other engineers on other tasks and projects as needed.</li>
</ul>
<br/>
<h1>Requirements:</h1>
<ul>
    <li>Degree in Information Technology, Computer Science, or other related fields.</li>
    <li>Minimum of 2 years' IT experience.</li>
    <li>Experience in MS SQL, Oracle, Postgres, NoSQL and MYSQL</li>
    <li>Highly experienced in Always On Availability Group, Failover Clustering, Database Mirroring, Backup and Restore, Optimizing Performance and T-SQL.</li>
    <li>Experience in Azure Cloud, SQLMI and SQL Database</li>
    <li>Good Communication and Team skills with the ability to cooperate, present to and participate with peers/team members.</li>
    <li>Good problem solving, analytical and critical thinking skills.</li>
</ul>`

export const jobs: Job[] = [
  {
    title: 'Junior Software Engineer (Frontend)',
    location: 'Central and Western, Hong Kong',
    type: 'Full-time',
    remote: 'Onsite',
    featured: true,
    employer: 'accenture',
    role: 'Software Engineer',
    createdAt: new Date('Mon Apr 8 2024 01:06:25 GMT+0800 (Malaysia Time)'),
    description: tempDescription,
    id: 'job-0',
    applications: ['ja-regular']
  },
  {
    title: 'Data Engineer',
    location: 'Central and Western, Hong Kong',
    type: 'Full-time',
    remote: 'Onsite',
    featured: false,
    employer: 'accenture',
    role: 'Data Science',
    createdAt: new Date('Mon Apr 8 2024 01:06:25 GMT+0800 (Malaysia Time)'),
    description: tempDescription,
    id: 'job-1',
    applications: ['ja-kydp-2024']
  },
  {
    title: 'Business Analyst',
    location: 'Central and Western, Hong Kong',
    type: 'Full-time',
    remote: 'Onsite',
    featured: false,
    employer: 'accenture',
    role: 'Data Science',
    createdAt: new Date('Mon Apr 8 2024 01:06:25 GMT+0800 (Malaysia Time)'),
    description: tempDescription,
    id: 'job-2',
    applications: ['ja-kydp-2024']
  },
  {
    title: 'Network Infrastructure Engineer',
    location: 'Central and Western, Hong Kong',
    type: 'Full-time',
    remote: 'Onsite',
    featured: false,
    employer: 'accenture',
    role: 'Network & Systems Administration',
    createdAt: new Date('Fri Apr 12 2024 01:06:25 GMT+0800 (Malaysia Time)'),
    description: tempDescription,
    id: 'job-3',
    applications: ['ja-kydp-2024-b']
  },
  {
    title: 'eCommerce Data Operations Specialist',
    location: 'Central, Hong Kong',
    type: 'Part-time',
    remote: 'Hybrid',
    featured: false,
    employer: 'dolphin',
    role: 'Data Science',
    createdAt: new Date('Wed Mar 27 2024 01:06:25 GMT+0800 (Malaysia Time)'),
    description: tempDescription,
    id: 'job-4',
    applications: ['ja-regular', 'ja-kl-cf-2024']
  },
  {
    title: 'Software Engineer (Backend)',
    location: 'Kuala Lumpur, Malaysia',
    type: 'Contract',
    remote: 'Remote',
    featured: true,
    employer: 'fave',
    role: 'Software Engineer',
    createdAt: new Date('Wed Mar 27 2024 01:06:25 GMT+0800 (Malaysia Time)'),
    description: tempDescription,
    id: 'job-5',
    applications: ['ja-regular']
  },
  {
    title: 'Drupal (PHP) Developer',
    location: 'Sai Kung, Hong Kong',
    type: 'Full-time',
    remote: 'Onsite',
    featured: true,
    employer: 'hkust',
    role: 'Software Engineer',
    createdAt: new Date('Tue Apr 2 2024 01:06:25 GMT+0800 (Malaysia Time)'),
    description: tempDescription,
    id: 'job-6',
    applications: ['ja-regular']
  },
  {
    title: 'Mobile / Java Developer',
    location: 'Sai kung, Hong Kong',
    type: 'Full-time',
    remote: 'Onsite',
    featured: true,
    employer: 'hkust',
    role: 'Software Engineer',
    createdAt: new Date('Tue Apr 2 2024 01:06:25 GMT+0800 (Malaysia Time)'),
    description: tempDescription,
    id: 'job-7',
    applications: ['ja-regular']
  },
  {
    title: 'Database Operator',
    location: 'Kuala Lumpur, Malaysia',
    type: 'Contract',
    remote: 'Remote',
    featured: true,
    employer: 'fave',
    role: 'Data Science',
    createdAt: new Date('Sun Apr 7 2024 01:06:25 GMT+0800 (Malaysia Time)'),
    description: tempDescription,
    id: 'job-8',
    applications: ['ja-regular']
  },
  {
    title: 'Social Media Manager',
    location: 'Kuala Lumpur, Malaysia',
    type: 'Contract',
    remote: 'Remote',
    featured: false,
    employer: 'dolphin',
    role: 'Digital Marketer',
    createdAt: new Date('Sun Apr 7 2024 01:06:25 GMT+0800 (Malaysia Time)'),
    description: tempDescription,
    id: 'job-9',
    applications: ['ja-regular', 'ja-kl-cf-2024']
  },
  {
    title: 'Cybersecurity Engineer',
    location: 'Petaling Jaya, Malaysia',
    type: 'Contract',
    remote: 'Remote',
    featured: false,
    employer: 'fave',
    role: 'Cybersecurity',
    createdAt: new Date('Sun Apr 7 2024 01:06:25 GMT+0800 (Malaysia Time)'),
    description: tempDescription,
    id: 'job-10',
    applications: ['ja-regular']
  },
  {
    title: 'UX Designer',
    location: 'Sai kung, Hong Kong',
    type: 'Full-time',
    remote: 'Onsite',
    featured: true,
    employer: 'hkust',
    role: 'UI/UX Designer',
    createdAt: new Date('Tue Apr 2 2024 01:06:25 GMT+0800 (Malaysia Time)'),
    description: tempDescription,
    id: 'job-11',
    applications: ['ja-regular']
  },
  {
    title: 'Business Development Manager',
    location: 'Sai kung, Hong Kong',
    type: 'Full-time',
    remote: 'Onsite',
    featured: true,
    employer: 'accenture',
    role: 'Business & Management',
    createdAt: new Date('Tue Apr 2 2024 01:06:25 GMT+0800 (Malaysia Time)'),
    description: tempDescription,
    id: 'job-12',
    applications: ['ja-regular']
  },
  {
    title: 'Cryptocurrency Analyst',
    location: 'Sai kung, Hong Kong',
    type: 'Full-time',
    remote: 'Onsite',
    featured: true,
    employer: 'fave',
    role: 'Financial Technology',
    createdAt: new Date('Tue Apr 2 2024 01:06:25 GMT+0800 (Malaysia Time)'),
    description: tempDescription,
    id: 'job-13',
    applications: ['ja-regular']
  }
]

export const myLocations = [
  'Johor|Malaysia',
  'Kedah|Malaysia',
  'Kelantan|Malaysia',
  'Malacca|Malaysia',
  'Negeri Sembilan|Malaysia',
  'Pahang|Malaysia',
  'Penang|Malaysia',
  'George Town|Penang|Malaysia',
  'Butterworth|Penang|Malaysia',
  'Perai|Penang|Malaysia',
  'Bukit Mertajam|Penang|Malaysia',
  'Bayan Lepas|Penang|Malaysia',
  'Perak|Malaysia',
  'Perlis|Malaysia',
  'Sabah|Malaysia',
  'Sarawak|Malaysia',
  'Selangor|Malaysia',
  'Ampang Jaya|Selangor|Malaysia',
  'Cheras|Selangor|Malaysia',
  'Cyberjaya|Selangor|Malaysia',
  'Damansara|Selangor|Malaysia',
  'Kajang|Selangor|Malaysia',
  'Klang|Selangor|Malaysia',
  'Petaling Jaya|Selangor|Malaysia',
  'Puchong|Selangor|Malaysia',
  'Puncak Alam|Selangor|Malaysia',
  'Shah Alam|Selangor|Malaysia',
  'Subang Jaya|Selangor|Malaysia',
  'Sungai Buloh|Selangor|Malaysia',
  'Terengganu|Malaysia',
  'Kuala Lumpur|Malaysia',
  'Labuan|Malaysia',
  'Putrajaya|Malaysia'
]
export const hkLocations = [
  // 'Eastern|Hong Kong',
  // 'Central and Western|Hong Kong',
  // 'Southern|Hong Kong',
  // 'Sham Shui Po|Hong Kong',
  // 'Kowloon City|Hong Kong',
  // 'Wong Tai Sin|Hong Kong',
  // 'Kwun Tong|Hong Kong',
  // 'Yau Tsim Mong|Hong Kong',
  // 'Kwai Tsing|Hong Kong',
  // 'Tsuen Wan|Hong Kong',
  // 'Tuen Mun|Hong Kong',
  // 'Yuen Long|Hong Kong',
  // 'North|Hong Kong',
  // 'Tai Po|Hong Kong',
  // 'Sha Tin|Hong Kong',
  // 'Sai Kung|Hong Kong',
  // 'Islands|Hong Kong',
  // 'Wan Chai|Hong Kong'
  'Hong Kong'
]

const cnLocations = [
  'Mainland|China',
  // // Municipalities
  // 'Beijing|China',
  // 'Chongqing|China',
  // 'Shanghai|China',
  // 'Tianjin|China',
  // // Major Cities in Provinces
  // 'Guangzhou|Guangdong|China',
  // 'Shenzhen|Guangdong|China',
  // 'Foshan|Guangdong|China',
  // 'Dongguan|Guangdong|China',
  // 'Zhongshan|Guangdong|China',
  // 'Hangzhou|Zhejiang|China',
  // 'Ningbo|Zhejiang|China',
  // 'Wenzhou|Zhejiang|China',
  // 'Nanjing|Jiangsu|China',
  // 'Suzhou|Jiangsu|China',
  // 'Wuxi|Jiangsu|China',
  // 'Changzhou|Jiangsu|China',
  // 'Chengdu|Sichuan|China',
  // 'Xian|Shaanxi|China',
  // 'Wuhan|Hubei|China',
  // 'Dalian|Liaoning|China',
  // 'Shenyang|Liaoning|China',
  // 'Harbin|Heilongjiang|China',
  // 'Qingdao|Shandong|China',
  // 'Jinan|Shandong|China',
  // // Autonomous Regions
  // 'Guangxi|China',
  // 'Inner Mongolia|China',
  // 'Ningxia|China',
  // 'Tibet|China',
  // 'Xinjiang|China',
  // // Provinces
  // 'Anhui|China',
  // 'Fujian|China',
  // 'Gansu|China',
  // 'Guangdong|China',
  // 'Guizhou|China',
  // 'Hainan|China',
  // 'Hebei|China',
  // 'Heilongjiang|China',
  // 'Henan|China',
  // 'Hubei|China',
  // 'Hunan|China',
  // 'Jiangsu|China',
  // 'Jiangxi|China',
  // 'Jilin|China',
  // 'Liaoning|China',
  // 'Qinghai|China',
  // 'Shaanxi|China',
  // 'Shandong|China',
  // 'Shanxi|China',
  // 'Sichuan|China',
  // 'Yunnan|China',
  // 'Zhejiang|China',
];

const macLocations = [
  'Macao'
  // Macao Administrative Divisions
  // 'Our Lady of Fátima|Macao',
  // 'St Lawrence|Macao',
  // 'St Joseph|Macao',
  // 'St Augustine|Macao',
  // 'Cathedral|Macao',
  // 'São Lourenço|Macao',
  // 'Nossa Senhora de Fátima|Macao',
  // 'Santo Agostinho|Macao',
  // 'São José|Macao'
];

export const locations = myLocations.concat(hkLocations).concat(cnLocations).concat(macLocations)

export const employmentTypes = ['FULL_TIME', 'PART_TIME', 'CONTRACT', 'INTERNSHIP']

export const remoteTypes = ['PHYSICAL', 'REMOTE', 'HYBRID']
